<div class="accordion-wrapper">
  <mat-accordion [multi]="true"
    cdkDropList
    (cdkDropListDropped)="onDrop($event)">
    @for (item of accordion; track item.id; let i = $index; let first = $first) {
      <mat-expansion-panel
        cdkDrag
        [cdkDragDisabled]="!showEditButton"
        class="animate__animated panel-custom"
        [expanded]="openState === accordionOpenState.OPEN || (openState === accordionOpenState.FIRST_OPEN && first)"
        [ngClass]="animationOptions?.enabled && animationOptions.animation"
        [class.error]="showError && (!item.text || !item.title)"
        [class.mat-elevation-z]="!shadow"
        [class.no-border]="!border"
        [autoTextDirection]="translation"
        [autoTextDirectionValue]="item.text"
        [style.animationDelay.ms]="(animationOptions?.delay || 0) + i * 200"
        [style.backdropFilter]="(item.enableBackground && item.backgroundBlur) ? ('blur(' + item.backgroundBlur + ')') : ''"
        [style.--lms-accordion-closed-color]="item.enableBackground ? item.headerClosedTextColor : ''"
        [style.--lms-accordion-closed-background]="item.enableBackground ? item.headerClosedBackgroundColor : ''"
        [style.--lms-accordion-opened-color]="item.enableBackground ? item.headerOpenedTextColor : ''"
        [style.--lms-accordion-opened-background]="item.enableBackground ? item.headerOpenedBackgroundColor : ''"
        [style.--lms-accordion-background]="item.enableBackground ? item.contentBackgroundColor : ''"
        #panel
        (afterExpand)="accordionOpened(i)">
        <mat-expansion-panel-header class="panel-header-custom" [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
          <span class="d-flex align-items-center pr-2 pr-sm-3">{{item.title}}</span>
          <lib-icon class="panel-header-icon" icon="caret-down"></lib-icon>
          @if (showEditButton) {
            <div class="card-actions">
              @if (!translation) {
                <button
                  mat-icon-button
                  cdkDragHandle
                  class="drag-handle button button--icon button--icon-extra-small button--black">
                  <lib-icon icon="equals"></lib-icon>
                </button>
              }
              <button
                mat-icon-button
                class="button button--icon button--icon-extra-small button--black"
                (click)="emitEdit($event, i)">
                <lib-icon icon="pencil-simple"></lib-icon>
              </button>
              @if (accordion?.length > 1 && !translation) {
                <button
                  mat-icon-button
                  class="button button--icon button--icon-extra-small button--black"
                  (click)="emitRemove($event, i)">
                  <lib-icon icon="trash"></lib-icon>
                </button>
              }
            </div>
          }
        </mat-expansion-panel-header>
        <div class="row panel-data-custom p-0">
          <div class="col-12 col-lg-8" [class.col-lg-12]="!item.mediaImage">
            <div class="ck-text" [padding]="spacing" [innerHTML]="item.text | safeHtml"></div>
          </div>
          @if (item.mediaImage) {
            <div class="col-12 col-lg-4 pl-lg-4">
              <img
                class="mb-3"
                [cropImage]="(item.mediaImage | preSignedUrl | async) || item.mediaImage?.url"
                [crop]="item?.mediaImage?.crop"
                [additionalOptions]="item?.mediaImage?.additionalMediaProps"
                alt="">
            </div>
          }
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
